import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {ToasterService} from "../../../../../services/core/toaster.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {first} from "rxjs/operators";
import {MeasurementUnitDataService} from "../../../measurement-unit/measurement-unit.data.service";

@Component({
    selector: 'app-add-unit-of-measurement',
    templateUrl: './add-unit-of-measurement.component.html',
    styleUrls: ['./add-unit-of-measurement.component.scss'],
    standalone: false
})
export class AddUnitOfMeasurementComponent implements OnInit {


  public sectionForm!: UntypedFormGroup;
  constructor(
    public toasterService: ToasterService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public measurementUnitDataService: MeasurementUnitDataService,
    public dialogRef: MatDialogRef<AddUnitOfMeasurementComponent>,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }
  initForm(){
    this.sectionForm = new UntypedFormGroup({
      name: new UntypedFormControl('' , [Validators.required]),
      status: new UntypedFormControl(1 , ),
    });
  }

  onConfirm = () => {
    if (this.sectionForm.invalid) {
      this.touchFormControls();
      return
    }
    this.measurementUnitDataService.create(this.sectionForm.value)
      .pipe(first())
      .subscribe(
        data => {
          this.close(data);
          this.toasterService.showSuccessMessage(data?.data?.message);
        });
  }
  touchFormControls(){
    Object.keys(this.sectionForm.controls).forEach(key => {
      this.sectionForm.get(key)?.markAsTouched();
    });
  }
  close = (data: any = null) => {
    this.dialogRef.close(data);
  }


}
